import CategoryNav from '@/components/feature/CategoryNav';

export default function CategorySection() {
  return (
    <section className="py-8 md:py-10">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950 whitespace-nowrap">
            <i className="ri-apps-2-line text-primary-500 mr-2"></i>
            视频分类
          </h2>
          <div className="flex-1 h-px bg-background-200"></div>
        </div>
        <CategoryNav activeCategory="all" useLink={true} />
      </div>
    </section>
  );
}